module.exports = __webpack_public_path__ + "img/mcu.8565fcf9.png";